import React, { Component } from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import history from "./history";

// Components
import SupportContainer from "./Containers/Support/SupportContainer";
import Footer from "./Components/Footer/Footer";
import Header from "./Components/Header/Header";
import Login from "./Containers/Login/Login";
import Logout from "./Containers/Logout/Logout";
import Logo from "../src/Assets/Images/GE_logo.svg";
import SfdcLogin from "./Containers/SfdcLogin/SfdcLogin";
import ProductUpdates from './Containers/Support/ProductUpdates/ProductUpdates'
import NativeSupport from './Containers/Support/NativeSupport';
import NativeAccount from './Containers/Account/NativeAccount';
export default class UnAuthenticatedRoutes extends Component {
  componentDidMount() {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 500);
  }

  render() {
    return (
      <>
        <Router history={history}>
          <div className="unauthorized-app-container">
            <Header Logo={Logo} />
            <div className="unauthorized-components-wrapper">
              <Switch>
                <Redirect exact from="/" to="/login" />
                <Route
                  exact
                  path="/login"
                  render={(props) => <Login {...props} isAuthorized={false} />}
                />
                <Route exact path='/login/sfdc' component={SfdcLogin} />
                <Route
                  exact
                  path="/support"
                  render={(props) => (
                    <SupportContainer {...props} isAuthorized={false} />
                  )}
                />
                <Route
                  exact
                  path="/productUpdate"
                  render={(props) => (
                    <ProductUpdates {...props} isAuthorized={false} />
                  )}
                />
                <Route
                  exact
                  path="/logout"
                  render={(props) => <Logout {...props} isAuthorized={false} />}
                />
                <Route
                  exact
                  path="/nativeSupport"
                  component={NativeSupport}
                />
                <Route
                  exact
                  path="/nativeAccount"
                  component={NativeAccount}
                />
                <Redirect from="*" to="/" />
              </Switch>
            </div>
            <Footer />
          </div>
        </Router>
      </>
    );
  }
}
